import { useCallback, useEffect, useState } from "react";

// Modo de operación para un profesional que también se atiende como paciente.
// Persistido en localStorage y sincronizado entre componentes vía un evento propio.
// Ver CLAUDE.md → "Profesional como paciente".

const STORAGE_KEY = "binapsis.doctor-mode";
const EVENT = "doctor-mode-change";

export const DOCTOR_MODE = {
  PROFESSIONAL: "professional",
  PATIENT: "patient",
};

function readMode() {
  try {
    return localStorage.getItem(STORAGE_KEY) === DOCTOR_MODE.PATIENT
      ? DOCTOR_MODE.PATIENT
      : DOCTOR_MODE.PROFESSIONAL;
  } catch {
    return DOCTOR_MODE.PROFESSIONAL;
  }
}

export default function useDoctorMode() {
  const [mode, setModeState] = useState(readMode);

  useEffect(() => {
    const handler = () => setModeState(readMode());
    window.addEventListener(EVENT, handler);
    window.addEventListener("storage", handler); // otras pestañas
    return () => {
      window.removeEventListener(EVENT, handler);
      window.removeEventListener("storage", handler);
    };
  }, []);

  const setMode = useCallback((next) => {
    localStorage.setItem(STORAGE_KEY, next);
    window.dispatchEvent(new Event(EVENT)); // notifica a esta pestaña
  }, []);

  return [mode, setMode];
}
